import { FunilVendaFaseSearch } from './fase';

export class FunilVendaSearchFunilVenda {
    id: number;
    tipo: number;
    nome: string;
    descricao: string;
    gerarCotacao: boolean;
    gerarPedidoVenda: boolean;

    fases: FunilVendaFaseSearch[];
}

export class FunilVendaSearchTotal {
    quantidadeFunisVendas: number;

    constructor() {
        this.quantidadeFunisVendas = 0;
    }
}

export class FunilVendaSearch {
    funisVendas: FunilVendaSearchFunilVenda[];
    total: FunilVendaSearchTotal;

    constructor() {
        this.funisVendas = [];
        this.total = new FunilVendaSearchTotal();
    }
}
